export enum MetadataStatus {
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  PUBLISHED = "PUBLISHED",
  HIDDEN = "HIDDEN",
  ARCHIVED = "ARCHIVED",
}

export enum Locale {
  PT = "PT",
  EN = "EN",
  ES = "ES",
  FR = "FR",
}

export interface Category {
  id?: number;
  slug: string;
  name: string;
  order: number;
  image?: string;
  icon?: string;
  showcase: boolean;
  searchable: boolean;
  filterable: boolean;
  minisite: boolean;
  navigation: boolean;
  status: MetadataStatus;
  parentId?: number;
  display_name: Record<string, string>;
  description: Record<string, string>;
  children?: Category[];
  /** Raw JSON recipe for a virtual category (see CategoryFilters). */
  filters?: string | null;
}

/** Virtual-category recipe: filters applied to the parent category. */
export interface CategoryFilters {
  search: Record<
    string,
    number | string | string[] | { min_price?: number; max_price?: number }[]
  >;
  lockedFacets: string[];
}

export type CategoryFilterKind = "number" | "text" | "csv" | "select" | "range";

export interface CategoryFilterOption {
  key: string;
  label: string;
  kind: CategoryFilterKind;
  options?: { value: string; label: string }[];
}

/** Search-payload keys a virtual category may set (must match the backend allowlist). */
export const CATEGORY_FILTER_OPTIONS: CategoryFilterOption[] = [
  { key: "screen_size_min", label: "Ecrã (mín, polegadas)", kind: "number" },
  { key: "screen_size_max", label: "Ecrã (máx, polegadas)", kind: "number" },
  { key: "brand", label: "Marca (produto)", kind: "text" },
  { key: "search_text", label: "Pesquisa por texto", kind: "text" },
  { key: "cpu_brand", label: "Marca CPU (Intel/AMD)", kind: "text" },
  { key: "gpu_brand", label: "Marca GPU (NVIDIA/AMD)", kind: "text" },
  { key: "memory", label: "RAM", kind: "text" },
  { key: "storage", label: "Disco", kind: "text" },
  { key: "tags", label: "Tags", kind: "csv" },
  { key: "price_range", label: "Preço (mín/máx)", kind: "range" },
  { key: "cpu", label: "CPU(s)", kind: "csv" },
  { key: "gpu", label: "GPU(s)", kind: "csv" },
  {
    key: "stock_status",
    label: "Disponibilidade",
    kind: "select",
    options: [
      { value: "in_stock", label: "Em stock" },
      { value: "last_units", label: "Últimas unidades" },
      { value: "out_of_stock", label: "Sem stock" },
    ],
  },
];

/**
 * Sidebar filter groups a virtual category may lock. A locked facet must also
 * set its search value (validated server-side) so the lock is enforced, not just
 * hidden in the UI.
 */
export const LOCKABLE_FACETS: { value: string; label: string }[] = [
  { value: "screen_size", label: "Tamanho Ecrã" },
  { value: "brand", label: "Marca" },
  { value: "memory", label: "RAM" },
  { value: "storage", label: "Disco" },
  { value: "cpu", label: "CPU" },
  { value: "gpu", label: "GPU" },
  { value: "stock", label: "Disponibilidade" },
  { value: "price", label: "Preço" },
  { value: "tags", label: "Tags" },
];
